import { FC, ReactNode } from "react";
import { UiButton } from "@domun/component-library";
import { DeliveryComplementaryEmptyStateWrapper } from "./delivery-complementary-empty-state.styled";

type DeliveryComplementaryEmptyStateProps = {
  icon: ReactNode;
  title: string;
  description: string;
  buttonLabel: string;
  onButtonPress: () => void;
};

export const DeliveryComplementaryEmptyState: FC<
  DeliveryComplementaryEmptyStateProps
> = ({ icon, title, description, buttonLabel, onButtonPress }) => (
  <DeliveryComplementaryEmptyStateWrapper>
    <div className="empty-state-icon">{icon}</div>
    <h4 className="empty-state-title">{title}</h4>
    <p className="empty-state-description">{description}</p>
    <UiButton appereance="outline" onClick={onButtonPress}>
      {buttonLabel}
    </UiButton>
  </DeliveryComplementaryEmptyStateWrapper>
);
